import { Component, Input } from "@angular/core";
import { UploadFile } from "@services";
import { JobDto } from "@shared/models";

@Component({
  selector: "abi-jobs-confirm",
  templateUrl: "./create-confirm.component.html",
  styleUrls: ["./create-confirm.component.scss"],
})
export class JobCreateConfirmComponent {
  @Input() job: JobDto;
  @Input() source: string;
  @Input() jobAtBranch = false;
  @Input() fileUploadEnabled = false;
  @Input() files: UploadFile[];
  @Input() showTitle = true;
  @Input() displaySections = ['contact', 'address', 'machine', 'job', 'dealer'];

  displaySection(name: string): boolean {
    return this.displaySections.includes(name);
  }

  getFileNames(): string[] {
    return this.files && Array.from(this.files).map(uf => {
      return uf.file.name;
    }) || [];
  }
}

